// SPECIFIC POP-IN SHOWING
var popinpro = {

  popin:                document.querySelector('[js-popinpro]'),
  popinRedirectButton:  document.querySelector('[js-popinpro-enable]'),
  popinHomeButton:      document.querySelector('[js-popinpro-home]'),
  popinMessage:         document.querySelector('[js-popinpro-message]'),

  close: function() {
    this.popin.classList.remove("opened");
  },

  home: function() {
    this.popinMessage.classList.add("opened");
  },

};

if (popinpro.popin) {
  popinpro.popinHomeButton.addEventListener("click", function() {
    popinpro.home();
  });

  popinpro.popinRedirectButton.addEventListener("click", function(e) {
    e.preventDefault();
    popinpro.close();
  });
}



// WEBPACK FOOTER //
// ./assets/scripts/components/_popin-pro.js